import React, {useEffect} from 'react';
import {Outlet, useSearchParams} from 'react-router-dom';
import {useShallow} from 'zustand/react/shallow';
import usePurchaseProcessEndedEvent from '@contentlab/hooks/analytics/use-purchase-process-ended-event';
import {FLOW_NAMES} from '@/lib/analytics/analyticsConstants';
import {
  getContentLabWebPaymentIds,
  removeContentLabWebPaymentIds,
} from '@/utils/LtidStorage';
import DoAndDontModal from '@/views/content-studio/components/do-and-dont-modal';
import contentStudioStore from '@/stores/contentStudioStore';

function ContentStudio() {
  const doAndDontModalFeature = contentStudioStore(
    useShallow((state) => state.doAndDontModalFeature)
  );

  const {purchaseProcessEnded} = usePurchaseProcessEndedEvent(
    FLOW_NAMES.CONTENT_STUDIO.PRICING
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const purchaseStatus = searchParams.get('purchaseStatus');

  const [result, error] = (() => {
    if (purchaseStatus === 'success' || purchaseStatus === 'cancel') {
      return [purchaseStatus, ''];
    }
    if (purchaseStatus === 'existingSubscriber') {
      return ['failure', 'existing_subscriber'];
    }
    return ['', ''];
  })();

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('purchaseStatus');
    setSearchParams(newSearchParams);
    if (purchaseStatus) {
      const webPaymentIds = getContentLabWebPaymentIds();
      purchaseProcessEnded({
        flow_id: webPaymentIds?.flowId || '',
        presentation_id: webPaymentIds?.presentationId || '',
        process_id: webPaymentIds?.processId || '',
        product_id: webPaymentIds?.productId || '',
        result,
        error,
        product_name: webPaymentIds?.productId || '',
      });

      removeContentLabWebPaymentIds();
    }
  }, []);
  return (
    <>
      <Outlet />
      <DoAndDontModal feature={doAndDontModalFeature} />
    </>
  );
}

export default ContentStudio;
